// Copy for the account area (profile, purchases, subscriptions, devices, language, currency and the account modals),
// used as t("ui.profile.*"). Numbers and dates are formatted in code and passed in as strings.
export default {
  title: "حساب کاربری",
  mobile: "شماره موبایل",
  userId: "شناسه کاربری",
  copy: "کپی",
  copied: "کپی شد",
  copyId: "کپی شناسه کاربری",
  version: "فونتا، نسخه",

  sub: {
    label: "اشتراک فونتا پرو",
    activeBefore: "فعال تا",
    activeAfter: "روز دیگر",
    endsToday: "امروز آخرین روز اشتراکته",
    endsOn: "پایان اشتراک: {{date}}",
    renew: "تمدید اشتراک",
    freeTitle: "هنوز پرو نشدی",
    freeBody: "با پرو همه فونت‌ها و پس‌زمینه‌ها باز می‌شن، فونت خودت رو اضافه می‌کنی و تبلیغی نمی‌بینی.",
    upgrade: "خرید اشتراک پرو",
  },

  groups: {
    settings: "تنظیمات",
  },
  rows: {
    invoices: "خریدهای من",
    receipts: "اشتراک‌ها",
    language: "زبان",
    currency: "واحد پول",
    devices: "دستگاه‌ها",
    support: "پشتیبانی",
    supportValue: "دایرکت اینستاگرام",
    logout: "خروج از حساب",
  },
  languageNames: {
    fa: "فارسی",
    en: "English",
  },

  planName: "اشتراک {{name}}",
  planFallback: "اشتراک پرو",

  receipts: {
    title: "اشتراک‌ها",
    history: "تاریخچه اشتراک‌ها",
    status: {
      available: "فعال",
      consumed: "استفاده شده",
      unavailable: "تموم شده",
    },
    emptyTitle: "هنوز اشتراکی نداری",
    emptyBody: "وقتی اشتراک پرو بخری، همه اشتراک‌هات اینجا میان.",
  },

  invoices: {
    title: "خریدهای من",
    status: {
      pending: "در انتظار بررسی",
      paid: "پرداخت شده",
      failed: "ناموفق",
      canceled: "لغو شده",
      refunded_with_revoke: "برگشت داده شده",
      refunded_with_fraud_revoke: "برگشت داده شده",
    },
    emptyTitle: "هنوز خریدی نکردی",
    emptyBody: "با خرید اشتراک پرو همه فونت‌ها و پس‌زمینه‌ها برات باز می‌شن. خریدهات اینجا نشون داده می‌شن.",
  },

  emptyCta: "خرید اشتراک پرو",

  devices: {
    title: "دستگاه‌ها",
    current: "همین دستگاه",
    online: "آنلاین",
    others: "دستگاه‌های دیگه",
    unknown: "دستگاه ناشناس",
    revoke: "خارج کن",
    revokeLabel: "خارج کن، {{name}}",
    hint: "اگه دستگاهی رو نمی‌شناسی، از حسابت خارجش کن.",
    emptyTitle: "دستگاه دیگه‌ای وارد حسابت نشده",
    emptyBody: "هر وقت با یه گوشی یا مرورگر دیگه وارد بشی، اینجا می‌بینیش و می‌تونی از راه دور خارجش کنی.",
    toastDone: "دستگاه از حسابت خارج شد",
    toastError: "یه مشکلی پیش اومد، دوباره امتحان کن",
    toastUnauthorized: "اجازه این کار رو نداری، یه بار دیگه وارد حسابت شو",
  },

  languages: {
    title: "زبان",
    hint: "زبان متن‌های سایت",
  },
  currencies: {
    title: "واحد پول",
    hint: "قیمت‌ها با این واحد نشون داده می‌شن.",
  },
  saving: "در حال ذخیره",

  pagination: {
    label: "صفحه‌ها",
    previous: "صفحه قبلی",
    next: "صفحه بعدی",
    page: "صفحه {{page}}",
  },

  modal: {
    close: "بستن",
  },
  revoke: {
    title: "این دستگاه از حسابت خارج بشه؟",
    body: "بعدش برای استفاده از فونتا روی اون دستگاه باید دوباره وارد حسابت بشی.",
    os: "سیستم عامل",
    browser: "مرورگر",
    country: "کشور",
    ip: "آی‌پی",
    lastSeen: "آخرین فعالیت",
    confirm: "خارجش کن",
    cancel: "بی‌خیال",
    wait: "یه لحظه صبر کن",
  },
};
